import { createAction, props } from '@ngrx/store';
import { FolderCreateRequest, FolderCreateResponse } from '@ms-organization-entities';
import { FolderRenameRequest, WorkspaceItem, WorkspaceMoveRequest } from '@primatoo-ms-organization';

export const createFolder = createAction('[folder] Create folder', props<{ request: FolderCreateRequest }>());
export const createFolderSuccess = createAction('[folder] Create folder Success', props<{
  response: FolderCreateResponse
}>());
export const createFolderFailed = createAction('[folder] Create folder Failed', props<{ error: any }>());

export const renameFolder = createAction('[folder] Rename folder', props<{
  id: number,
  request: FolderRenameRequest
}>());
export const renameFolderSuccess = createAction('[folder] Rename folder Success', props<{ id: number }>());
export const renameFolderFailed = createAction('[folder] Rename folder Failed', props<{ error: any }>());

export const moveFolder = createAction('[folder] Move folder', props<{
  id: number,
  workspaceMoveRequest: WorkspaceMoveRequest
}>());
export const moveFolderSuccess = createAction('[folder] Move folder Success', props<{ item: WorkspaceItem }>());
export const moveFolderFailed = createAction('[folder] Move folder Failed', props<{ error: any }>());

export const deleteFolderSuccess = createAction('[folder] Delete folder Success');
export const deleteFolderFailed = createAction('[folder] Delete folder Failed', props<{ error: any }>());
